import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import GrabacionIMG from "../../assets/app/ServicesSection/ICO-TELEFONO.png";
import TranscripcionIMG from "../../assets/app/ServicesSection/ICO-TRANSCRIPCION.png";
import "../../styles/app/ServicesSection.css";

const ServicesSection: React.FC = () => {
  const { t } = useTranslation();
  const imageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const el = imageRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const xPercent = (x / rect.width - 0.5) * 2;
      const yPercent = (y / rect.height - 0.5) * 2;

      const maxTranslate = 10;
      el.style.setProperty("--translateX", `${xPercent * maxTranslate}px`);
      el.style.setProperty("--translateY", `${yPercent * maxTranslate}px`);
    };

    const section = imageRef.current;
    if (section) {
      section.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      if (section) {
        section.removeEventListener("mousemove", handleMouseMove);
      }
    };
  }, []);

  return (
    <section className="services-section">
      <div className="services-heading">
        <h1 className="services-title">
          {t("servicesSection.title")}
        </h1>
        <p className="services-desc">
          {t("servicesSection.description")}
        </p>
      </div>
      <div className="services-image-wrapper">
        <div className="services-icons-row">
          <div className="services-icon-block">
            <img
              src={GrabacionIMG}
              alt="Icono 1"
              className="services-icon-image"
            />
            <p className="services-icon-text">{t("servicesSection.callRecording")}</p>
          </div>
          <div className="services-icon-block">
            <img
              src={TranscripcionIMG}
              alt="Icono 2"
              className="services-icon-image"
            />
            <p className="services-icon-text">{t("servicesSection.callTranscription")}</p>
          </div>
        </div>
        <div className="services-image" ref={imageRef}></div>
      </div>
    </section>
  );
};

export default ServicesSection;
